import { ReactElement } from "react";
import { Redirect } from "react-router-dom";
import { hasPermission, Permission } from "react-ai-platform-auth";

import { useAuthContext } from "../authHelper";
import LoadingComponent from "../components/LoadingIndicators/LoadingComponent";
import { LIONBRIDGE_CMP, PROJECTS, SNAKE } from "../routes";

enum SnakeRedirectPage {
  SIGNIN = "signin",
  RESET_PASSWORD = "reset_password",
  FORGOT_PASSWORD = "forgot_password",
}

const SnakeRedirect = (pageToRedirect: SnakeRedirectPage): ReactElement => {
  const { isAuthenticated, isLoading, user } = useAuthContext();
  const searchParams = new URLSearchParams(location.search);
  const redirectUrl = searchParams.get("redirect") || "";
  const passwordToken = searchParams.get("password_reset_token") || "";
  let redirectionUrl: string;

  if (!isLoading) {
    switch (pageToRedirect) {
      case SnakeRedirectPage.SIGNIN:
        if (isAuthenticated) {
          if (hasPermission(user, Permission.READ_PROJECTS)) {
            return <Redirect to={PROJECTS.LIST} />;
          } else {
            window.location.replace(`${LIONBRIDGE_CMP.HOME}`);
            return <LoadingComponent title="Loading..." />;
          }
        }

        if (/^(http(s?)):\/\//i.test(redirectUrl)) {
          redirectionUrl = SNAKE.HOME + "/?redirect=" + redirectUrl;
          break;
        }

        redirectionUrl = SNAKE.HOME + "/?redirect=" + window.location.origin + redirectUrl;
        break;

      case SnakeRedirectPage.RESET_PASSWORD:
        redirectionUrl = SNAKE.RESET_PASSWORD + passwordToken;
        break;

      case SnakeRedirectPage.FORGOT_PASSWORD:
        redirectionUrl = SNAKE.FORGOT_PASSWORD;
        break;
    }

    window.location.replace(redirectionUrl);
  }

  return <LoadingComponent title="Loading..." />;
};

const SnakeSignInRedirect = (): ReactElement => {
  return SnakeRedirect(SnakeRedirectPage.SIGNIN);
};

const SnakePasswordResetRedirect = (): ReactElement => {
  return SnakeRedirect(SnakeRedirectPage.RESET_PASSWORD);
};

const SnakeForgotPasswordRedirect = (): ReactElement => {
  return SnakeRedirect(SnakeRedirectPage.FORGOT_PASSWORD);
};

export { SnakeSignInRedirect, SnakePasswordResetRedirect, SnakeForgotPasswordRedirect };
